// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"58":"8358f01a","135":"a8970944","529":"c9f922b3","787":"99266118","925":"6c2cec44","976":"13893d90"}[chunkId] + ".css";
};